type DevMagicLink = {
  email: string
  url: string
  expires: Date
  createdAt: Date
}

const globalForDevLinks = globalThis as typeof globalThis & {
  __askQienDevMagicLinks?: Map<string, DevMagicLink>
}

const links = globalForDevLinks.__askQienDevMagicLinks ?? new Map<string, DevMagicLink>()
globalForDevLinks.__askQienDevMagicLinks = links

export function storeDevMagicLink(input: { email: string; url: string; expires: Date }) {
  links.set(input.email.toLowerCase(), {
    ...input,
    email: input.email.toLowerCase(),
    createdAt: new Date(),
  })
}

export function getDevMagicLink(email: string): DevMagicLink | null {
  if (process.env.NODE_ENV === 'production') return null
  const link = links.get(email.toLowerCase())
  if (!link || link.expires < new Date()) return null
  return link
}

export function shouldUseDevMagicLinks(): boolean {
  return process.env.NODE_ENV !== 'production' && process.env.AUTH_DEV_EMAIL_MODE !== 'smtp'
}
